import { CollapsibleCard, type ToolRendererProps } from '../ToolCard';

interface FetchResult {
  title?: string;
  url?: string;
  content?: string;
  text?: string;
}

function hostname(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return url;
  }
}

export function WebFetchCard({ toolName, result }: ToolRendererProps) {
  if (!result || typeof result !== 'object') {
    return (
      <CollapsibleCard toolName={toolName}>
        <pre className="text-[11px] text-espresso">{JSON.stringify(result)}</pre>
      </CollapsibleCard>
    );
  }

  const r = result as FetchResult;
  const body = r.content ?? r.text ?? '';
  const preview = body.slice(0, 200);
  const truncated = body.length > 200;

  return (
    <CollapsibleCard toolName={toolName} defaultOpen>
      {r.title && <div className="text-xs font-medium text-espresso">{r.title}</div>}
      {r.url && (
        <a
          href={r.url}
          target="_blank"
          rel="noopener noreferrer"
          className="block truncate text-[10px] text-gold hover:underline"
        >
          {hostname(r.url)}
        </a>
      )}
      {body && (
        <p className="mt-1 text-xs text-bark">
          {preview}
          {truncated && '…'}
        </p>
      )}
    </CollapsibleCard>
  );
}
